"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/helpers/classCallCheck.js
// module id = 117
// module chunks = 1 2 3 6 7 8 10 11 12 13 14 16 17 21 22 23 25 26 27 28 29 31 32 33 34 35 36 37 38 40 41 45 46 49 51